export default __webpack_public_path__ + "static/media/Maithili_bm_2.99de18d9.mp3";